// extracted by mini-css-extract-plugin
export default {"section":"FunFacts_section__X09CX","wrapper":"FunFacts_wrapper__KGYNg"};